// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__3n3u4","error":"Textarea_error__2xOqV","readonly":"Textarea_readonly__b73hz","disabled":"Textarea_disabled__X7_pt"};